// extracted by css-extract-rspack-plugin
export default {"InteractionSurface":"InteractionSurface--vre9m"};